import type { FaireProductEntity } from "../../entity_types/product";

export const p_ajdqkwaz9p: FaireProductEntity = {
  token: "p_ajdqkwaz9p",
  type: "product",
  name: "Albers Short Sleeve Sweater Tee - Avocado (Faire Pre-Order)",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/e5c726e3cbe52a01fe9f01389b29d57551b0ef77ecc3b359c26665866a5277f8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/25c3251018248a00d8f2b395291e49072b9f0d72003cb11942206d07fa335e89.jpeg",
    "https://cdn.faire.com/fastly/c7bb69c90b2a06e5c10873120bad5450a08ae84ab2b11e765e3e3af54b6450bc.jpeg",
    "https://cdn.faire.com/fastly/2aa1e61da65f4b0838bfa2f21cba549d63659c47c285e992a2e6c0ba7dfbe25c.jpeg",
    "https://cdn.faire.com/fastly/4a83b40a2f968e2375c70e838760b452c9ec5c437db1d141cc73e0861a0c87ab.jpeg",
    "https://cdn.faire.com/fastly/3e3d8db75032cc26a455dab8063a70a7c12f4ffe930733e38bdc713239bb4aff.jpeg",
    "https://cdn.faire.com/fastly/ae6ca7528b53b299894f851f4937e98988ffe4c41bc6af5fcfa78eb65bfa6773.jpeg",
    "https://cdn.faire.com/fastly/dd4da9b240a0bc76411d8520c9c7e5d6e29bd2742993727f6d14506eda3cacf1.jpeg"
  ],
  priceDollars: 75.6,
  description: "A statement in structure. The Albers Tee features an asymmetric jacquard knit in deadstock Pima cotton, blending artful design with everyday ease.\n\n * \nSlightly cropped and boxy body\n\n * \n100% deadstock Pima Cotton\n\n * \nArtisan made in Peru with Fair Trade practices to maintain ethical and responsible integrity\n\n\n",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:25.210Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
